import PropTypes from "prop-types";
import { AboutMe } from "./AboutMe";
import { GenericAccordionItem } from "./GenericAccordionItem";
import { ProductDetails } from "./ProductDetails";
import { MoreInfo } from "./MoreInfo";

export function MergedProductDetails({ productDescription }) {
  return (
    <>
      <ProductDetails
        productDescription={productDescription.productDescription}
        productDescriptionVisible={productDescription.productDescriptionVisible}
      />
      <GenericAccordionItem
        content={productDescription.careInfo}
        isVisible={productDescription.careInfoVisible}
      />
      <AboutMe
        aboutMe={productDescription.aboutMe}
        aboutMeVisible={productDescription.aboutMeVisible}
      />
      <GenericAccordionItem
        content={productDescription.brandDescription}
        isVisible={productDescription.brandDescriptionVisible}
      />
      <MoreInfo
        badges={productDescription.badges}
        moreInfoVisible={productDescription.moreInfoVisible}
      />
    </>
  );
}

MergedProductDetails.propTypes = {
  productDescription: PropTypes.shape({
    aboutMe: PropTypes.string,
    aboutMeVisible: PropTypes.bool,
    badges: PropTypes.arrayOf(
      PropTypes.shape({
        contentUrl: PropTypes.string.isRequired,
        tooltip: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
      })
    ),
    brandDescription: PropTypes.string,
    brandDescriptionVisible: PropTypes.bool,
    careInfo: PropTypes.string,
    careInfoVisible: PropTypes.bool,
    moreInfoVisible: PropTypes.bool,
    productDescription: PropTypes.string,
    productDescriptionVisible: PropTypes.bool,
  }),
};
